import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Mountain, MailCheck, Loader2, ArrowLeft } from "lucide-react";
import { toast } from "sonner";
import { DISCLAIMER } from "@/lib/constants";
import api from "@/lib/api";

export default function ForgotPassword() {
    const [email, setEmail] = useState("");
    const [loading, setLoading] = useState(false);
    const [sent, setSent] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
            setSent(true);
        } catch (err) {
            toast.error("Não foi possível enviar agora. Tente novamente.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
            <div className="w-full max-w-md bg-white border border-slate-200 rounded-lg shadow-sm p-8">
                <Link to="/" className="flex items-center gap-2 font-heading font-black text-xl text-petroleum mb-6" data-testid="forgot-logo">
                    <Mountain className="w-7 h-7 text-mineral" /> GEOMINE MANAGER
                </Link>
                {sent ? (
                    <div className="text-center" data-testid="forgot-sent">
                        <div className="mx-auto w-14 h-14 rounded-full bg-green-50 flex items-center justify-center mb-4">
                            <MailCheck className="w-7 h-7 text-green-600" />
                        </div>
                        <h1 className="font-heading text-2xl font-black text-slate-900">Verifique seu e-mail</h1>
                        <p className="text-slate-500 mt-2">Se houver uma conta com <strong>{email}</strong>, enviamos um link para redefinir sua senha. O link expira em 1 hora.</p>
                        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-petroleum font-semibold" data-testid="forgot-back-login"><ArrowLeft className="w-4 h-4" /> Voltar ao login</Link>
                    </div>
                ) : (
                    <>
                        <h1 className="font-heading text-2xl font-black text-slate-900">Esqueci minha senha</h1>
                        <p className="text-slate-500 mt-2">Informe seu e-mail e enviaremos um link para você criar uma nova senha.</p>
                        <form onSubmit={submit} className="mt-6 space-y-4">
                            <div>
                                <label className="text-sm font-semibold text-slate-700">E-mail</label>
                                <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="forgot-email-input"
                                    className="mt-1 w-full rounded-md border-2 border-slate-200 focus:border-petroleum outline-none px-4 py-2.5 transition-colors" placeholder="voce@exemplo.com" />
                            </div>
                            <button type="submit" disabled={loading} data-testid="forgot-submit-button"
                                className="w-full flex items-center justify-center gap-2 bg-petroleum hover:bg-petroleumHover text-white rounded-md px-6 py-3 font-semibold transition-colors disabled:opacity-60">
                                {loading && <Loader2 className="w-4 h-4 animate-spin" />} Enviar link de redefinição
                            </button>
                        </form>
                        <Link to="/login" className="mt-6 inline-flex items-center gap-2 text-slate-500 hover:text-petroleum text-sm font-semibold" data-testid="forgot-back-login"><ArrowLeft className="w-4 h-4" /> Voltar ao login</Link>
                    </>
                )}
                <p className="mt-8 text-xs text-slate-400 leading-relaxed">{DISCLAIMER}</p>
            </div>
        </div>
    );
}
